import { render, staticRenderFns } from "./PurDL_Purchase_Delivery.vue?vue&type=template&id=6e4b0979"
import script from "./PurDL_Purchase_Delivery.vue?vue&type=script&lang=js"
export * from "./PurDL_Purchase_Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports